import React from "react";
import TeamsApp from "./TeamLayout";

/**
 * Teams Bridge Component
 * Integrates team management system with existing app authentication
 */
const TeamsBridge = ({ token, user, onLogout }) => {
  // Pass authentication data directly as props instead of using AuthContext
  // Phase 1.1: Check user existence instead of token (tokens are in HttpOnly cookies)
  return (
    <TeamsApp
      currentUser={user}
      isAuthenticated={!!user}
      token={token}
      onLogout={onLogout}
    />
  );
};

export default TeamsBridge;
